import React from 'react'
import { Text } from '@mantine/core'

interface GuaranteedDrawHintProps {
  remainingDrawsToGuaranteed?: number
}

const GuaranteedDrawHint: React.FC<GuaranteedDrawHintProps> = ({ remainingDrawsToGuaranteed }) => {
  if (remainingDrawsToGuaranteed === undefined || remainingDrawsToGuaranteed >= 6) {
    return null
  }

  const isGuaranteed = remainingDrawsToGuaranteed === 0

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 12,
        marginTop: 4,
      }}
    >
      <div
        style={{
          background: isGuaranteed
            ? 'linear-gradient(135deg, #FF6B6B 0%, #FF4757 100%)'
            : 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          padding: '6px 16px',
          borderRadius: '20px',
          border: isGuaranteed ? '2px solid #FF3742' : '2px solid #FF8C00',
          boxShadow: isGuaranteed ? '0 2px 8px rgba(255, 55, 66, 0.4)' : '0 2px 8px rgba(255, 140, 0, 0.3)',
          animation: 'pulse 2s ease-in-out infinite',
        }}
      >
        <Text
          style={{
            fontSize: 13,
            color: isGuaranteed ? '#FFF' : '#8B4513',
            fontWeight: 700,
            textShadow: isGuaranteed ? '0 1px 2px rgba(0, 0, 0, 0.3)' : '0 1px 2px rgba(255, 255, 255, 0.8)',
          }}
        >
          {isGuaranteed
            ? '🔥 恭喜！本次抽奖必中现金红包！'
            : `💰 最多再抽 ${remainingDrawsToGuaranteed} 次必得现金红包！`}
        </Text>
      </div>
    </div>
  )
}

export default GuaranteedDrawHint
